import { createTheme, type Theme } from '@mui/material/styles'
import { roRO, enUS } from '@mui/material/locale'

/**
 * Paleta urmează anexa „Harta ecranelor": neutre reci cu o urmă de verde,
 * accent verde-petrol. Culorile semantice sunt distincte de accent, ca starea
 * (bine / atenție / critic) să nu se confunde cu identitatea vizuală.
 */
const accent = { main: '#0E5E5A', light: '#3C8B85', dark: '#0A4744', contrastText: '#FFFFFF' }
const accentDark = { main: '#54B6AD', light: '#7ACCC4', dark: '#2C7A73', contrastText: '#04211F' }

export function buildTheme(mode: 'light' | 'dark', language: string): Theme {
  const locale = language === 'en' ? enUS : roRO
  const isDark = mode === 'dark'

  return createTheme(
    {
      palette: {
        mode,
        primary: isDark ? accentDark : accent,
        secondary: { main: isDark ? '#8FA8A4' : '#4A5C59' },
        success: { main: isDark ? '#5FB37A' : '#2E7D44' },
        warning: { main: isDark ? '#D9A03F' : '#A86400' },
        error: { main: isDark ? '#E0796C' : '#A93226' },
        info: { main: isDark ? '#61A8DC' : '#155E96' },
        background: {
          default: isDark ? '#0D1312' : '#F4F6F5',
          paper: isDark ? '#151D1C' : '#FFFFFF',
        },
        text: {
          primary: isDark ? '#E6EDEB' : '#12191A',
          secondary: isDark ? '#95A4A0' : '#5A6764',
        },
        divider: isDark ? '#26302E' : '#DCE3E1',
      },
      shape: { borderRadius: 6 },
      typography: {
        fontFamily: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", sans-serif',
        fontSize: 14,
        h1: { fontSize: '2rem', fontWeight: 600, letterSpacing: '-0.015em' },
        h2: { fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.01em' },
        h3: { fontSize: '1.25rem', fontWeight: 600 },
        h6: { fontSize: '1.0625rem', fontWeight: 600, letterSpacing: '-0.005em' },
        button: { textTransform: 'none', fontWeight: 500 },
        overline: { letterSpacing: '0.1em', fontSize: '0.6875rem', fontWeight: 600 },
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            // Cifrele se aliniază pe coloană oriunde se compară valori (NFR-USA-007)
            '.tabular, .MuiDataGrid-cell--numeric, td[data-numeric]': {
              fontVariantNumeric: 'tabular-nums',
              fontFamily: '"IBM Plex Mono", ui-monospace, monospace',
            },
          },
        },
        MuiButton: { defaultProps: { disableElevation: true } },
        MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { backgroundImage: 'none' } } },
        MuiTextField: { defaultProps: { size: 'small' } },
        MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
      },
    },
    locale,
  )
}
